import { IAppState } from '../../store';

export const selectComment = (state: IAppState) => state.personalLeadsForm.data.comment;
